import { useQuery } from "@tanstack/react-query";

import { materialsQuery } from "#modules/materials/infra/materials.query";

export const useMaterials = () => {
  const { data, ...rest } = useQuery({ ...materialsQuery() });

  return { materials: data ?? [], ...rest };
};
